/** Shared elevation for workspace components on the dispatch floor. */
export const WORKSPACE_SURFACE_RADIUS = 'var(--mantine-radius-md)'

export const WORKSPACE_SURFACE_SHADOW =
    '0 1px 2px rgba(16, 24, 40, 0.06), 0 1px 3px rgba(16, 24, 40, 0.1)'

/** Swim-lane boards: open into the page — no outer chrome border. */
export const WORKSPACE_SWIM_LANE_BOARD_SURFACE = {
    border: 'none',
} as const

export const WORKSPACE_TIMELINE_SURFACE = {
    border: '1px solid var(--mantine-color-gray-4)',
    borderRadius: WORKSPACE_SURFACE_RADIUS,
} as const

export const WORKSPACE_QUEUE_SURFACE = {
    border: '1px solid var(--mt-signal-attention-4)',
    borderRadius: WORKSPACE_SURFACE_RADIUS,
    boxShadow: WORKSPACE_SURFACE_SHADOW,
} as const
